import Blizfieldf1 from '../../../Media/Fasilitas BSD/Blizfield/15.webp'
import Blizfieldf2 from '../../../Media/Fasilitas BSD/Blizfield/16.webp'





const Blizfieldfimages =[
Blizfieldf1,Blizfieldf2
]

export default Blizfieldfimages;